export default __webpack_public_path__ + "static/travelrapid_step3-eb3cd6064df626e33e018146757f2c16.svg";